import Grid from "@material-ui/core/Grid";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import withStyles from "@material-ui/core/styles/withStyles";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import classNames from "classnames";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as _ from "underscore";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  setSaveProgress,
  removeSaveProgress,
} from "Actions/SaveProgressAction";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import CustomLoader from "Component/CustomLoader";


import {
  setHelperText,
  CheckActionPermission,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import { ValidateMultiselectList } from "../../../../../Utils/Validation";
import { CalculateHieght } from "../../../../../Assets/Js/CustomForm";
import ActiveIcon from "../../../../../Assets/Images/aaa.png";
import SelectList from "../../../../../Component/SelectList/SelectList";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  tabheading: {
    fontSize: 16,
    textTransform: "capitalize",
    padding: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
});

class LeavePlanForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOptions: [],
      errors: {},
      plan: [],
      categories: "",
      leaveTypes: [],
      categorieTypes: "",
      isDisabled: false,
      ismadeavailable: false,
      isleavebalancehigh: false,
      LeaveBalance: [
        { displayvalue: 0, displayname: "0" },
        { displayvalue: 1, displayname: "1" },
        { displayvalue: 2, displayname: "2" },
        { displayvalue: 3, displayname: "3" },
        { displayvalue: 4, displayname: "4" },
        { displayvalue: 5, displayname: "5" },
        { displayvalue: 6, displayname: "6" },
        { displayvalue: 7, displayname: "7" },
        { displayvalue: 8, displayname: "8" },
        { displayvalue: 9, displayname: "9" },
        { displayvalue: 10, displayname: "10" },
      ],
      mailtriggereddays: 0,
      options: [
        { displayvalue: true, displayname: "Yes" },
        { displayvalue: false, displayname: "No" },
      ],
      TriggeredError: false,
      permissions: { readOnly: false, editable: false },
    };
  }

  componentWillMount() {
    this.props.ChangeLanguage("leaveplan");
    this.getMasterCAtegories();
    // this.getCategories();
    const [isTrue, permissions] = CheckActionPermission("leavePlan");
    if (isTrue) {
      this.setState({ permissions });
    }
  }

  componentDidMount() {
    this.props.setHelperText({
      helperText: "Helper text for Leave Plan",
      open: false,
    });
  }

  getCategories() {
    let categories = "";
    categories = _.groupBy(this.state.plan, "categoryname");
    this.setState({ categories }, () => {
      this.GetLeaveTypes(this.state.categories, 0);
    });
  }

  HandleKeyDown(e) {
    if ([69, 187, 188, 189, 190, 107, 109, 110].includes(e.keyCode)) {
      e.preventDefault();
    }
  }

  GetLeaveTypes(arr) {
    let subscriptionid;
    let ismadeavailable;
    let isleavebalancehigh;
    let mailtriggereddays;
    const selectedOptions = [];
    const leaveTypes = [];
    const categorieTypes = [];
    _.each(arr, (value, key) => {
      leaveTypes.push(value);
      categorieTypes.push(key);
    });

    Object.keys(leaveTypes).map((option) => {
      {
        leaveTypes[option].map((type) => {
          if (type.subscriptionplanid != 0) {
            // if( type.leavetypeid != 4 && type.leavetypeid != 5)
            selectedOptions.push(type);
          }
          if (type.leavetypeid == 4 || type.leavetypeid == 5) {
            subscriptionid = type.subscriptionplanid;
          }
        });
      }
    });
    if (selectedOptions.length > 0) {
      let index;
      let index2;
      index = selectedOptions.findIndex((x) => x.leavetypeid == 4);
      if (index != -1) {
        ismadeavailable = selectedOptions[index].ismadeavailable;
        isleavebalancehigh = selectedOptions[index].isleavebalancehigh;
        mailtriggereddays = selectedOptions[index].mailtriggereddays;
        selectedOptions.splice(index, 1);
      }
      index2 = selectedOptions.findIndex((y) => y.leavetypeid == 5);
      if (index2 != -1) {
        selectedOptions.splice(index2, 1);
      }
    }
    if (subscriptionid != 0) {
      selectedOptions.push({
        leavetypeid: 4,
        categoryid: 1,
        datastate: 1,
        ismadeavailable,
        isleavebalancehigh,
        mailtriggereddays,
      });
      selectedOptions.push({
        leavetypeid: 5,
        categoryid: 1,
        datastate: 1,
        ismadeavailable,
        isleavebalancehigh,
        mailtriggereddays,
      });
    } else {
      selectedOptions.push({
        leavetypeid: 4,
        categoryid: 1,
        datastate: 1,
        ismadeavailable: false,
        isleavebalancehigh: false,
        mailtriggereddays: null,
      });
      selectedOptions.push({
        leavetypeid: 5,
        categoryid: 1,
        datastate: 1,
        ismadeavailable: false,
        isleavebalancehigh: false,
        mailtriggereddays: null,
      });
    }
    if (selectedOptions.length > 0) {
      if (selectedOptions[0].ismadeavailable == null) {
        ismadeavailable = false;
      } else {
        ismadeavailable = selectedOptions[0].ismadeavailable;
      }
      if (selectedOptions[0].isleavebalancehigh == null) {
        isleavebalancehigh = false;
      } else {
        isleavebalancehigh = selectedOptions[0].isleavebalancehigh;
      }
      mailtriggereddays = selectedOptions[0].mailtriggereddays;
    }
    this.setState({
      leaveTypes,
      categorieTypes,
      selectedOptions,
      ismadeavailable,
      isleavebalancehigh,
      mailtriggereddays,
    });
  }

  UpdateLeavesAvailable(name, flag, selectedItem, selectedIndex) {
    this.setState({ [name]: selectedItem.displayvalue });
    const text = "Helper text for Notifications";
    this.props.setHelperText({ helperText: text, open: flag });
  }

  UpdatehighBalance(name, flag) {
    this.setState({ [name]: flag });
    const text = "Helper text for Notifications";
    this.props.setHelperText({ helperText: text, open: flag });
  }

  getMasterCAtegories() {
    instance
      .get("/leaves/masterandsubleavetype")
      .then((result) => {
        let plan = [];
        result.data.result.length > 0
          ? (plan = result.data.result)
          : (plan = []);
        this.setState({ plan }, () => {
          this.getCategories();
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  HandleMultiSelect = (selectedOption, flag) => {
    const index = this.state.selectedOptions.findIndex(
      (item) => item.leavetypeid == selectedOption.leavetypeid,
    );
    const { selectedOptions } = this.state;
    // &&(selectedOption.leavetypeid !=4||selectedOption.leavetypeid !=5)
    if (index == -1) {
      selectedOptions.push(selectedOption);
    } else if (
      selectedOption.leavetypeid != 4 &&
      selectedOption.leavetypeid != 5
    ) {
      selectedOptions.splice(index, 1);
    }
    this.setState({ selectedOptions });
    const text = `${"Helper text for" + " "}${selectedOption.leavetypename}`;
    this.props.setHelperText({ helperText: text, open: flag });
  };

  UpdateLeaveBalance(selectedIndex) {
    const mailtriggereddays = selectedIndex;
    this.setState({ mailtriggereddays });
  }

  HandleMultiChange = (name, selectedOption) => {
    const index = this.state.selectedOptions.findIndex(
      (item) => item == selectedOption.leavetypeid,
    );
    const { selectedOptions } = this.state;
    if (index != -1) {
      selectedOptions.splice(index, 1);
    } else {
      selectedOptions.push(selectedOption.leavetypeid);
    }
    // this.props.SetMarkdown(HtSelectServices)
    ValidateMultiselectList(this.state, name);
    this.setState({ selectedOptions }, () => {
      // this.CalculateTotals();
      CalculateHieght();
    });
  };

  selHelperText(flag, text) {
    this.props.setHelperText({ helperText: text, open: flag });
  }

  OnFieldChangeNumber(flag, e) {
    if (e.target.value <= 100) {
      const onlyNums = e.target.value.replace(/[^0-9]/g, "");

      this.setState({ mailtriggereddays: onlyNums });
    } else {
    }

    const text = "Helper text regarding getting high leave balance mail";
    this.props.setHelperText({ helperText: text, open: flag });
    this.setState({ TriggeredError: false });
  }

  onSaveClick() {
    
    // console.log("clicked");
    // return;
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    const newPlan = [];
    if (
      (this.state.mailtriggereddays == null ||
        this.state.mailtriggereddays == "") &&
      this.state.isleavebalancehigh == true
    ) {
      this.setState({ TriggeredError: true });
    } else {
      this.state.selectedOptions.forEach((element) => {
        newPlan.push({
          leavetypeid: element.leavetypeid,
          leavecategoryid: element.categoryid,
          datastate: 1,
          ismadeavailable: this.state.ismadeavailable,
          isleavebalancehigh: this.state.isleavebalancehigh,
          mailtriggereddays: this.state.mailtriggereddays,
        });
      });
      Object.keys(this.state.leaveTypes).map((option) => {
        {
          this.state.leaveTypes[option].map((type) => {
            const index = this.state.selectedOptions.findIndex(
              (item) => item.leavetypeid == type.leavetypeid,
            );
            if (index == -1) {
              newPlan.push({
                leavetypeid: type.leavetypeid,
                leavecategoryid: type.categoryid,
                datastate: 0,
                ismadeavailable: this.state.ismadeavailable,
                isleavebalancehigh: this.state.isleavebalancehigh,
                mailtriggereddays: this.state.mailtriggereddays,
              });
            }
          });
        }
      });
      const data = {
        subscriptionleaveplan: newPlan,
      };
      if (!issaveinprogress) {
        this.props.setSaveProgress(true);
        this.setState({issaving:true}, () => {

     
      instance
        .post("/leaves/subscriptionleaveplan", data)
        .then((result) => {
          this.props.removeSaveProgress();
          
          this.setState({issaving:false})
          this.props.enqueueSnackbar("Leave plan saved successfully", {
            variant: "success",
          });

          // this.props.history.push('./planform');
          this.getMasterCAtegories();
        })
        .catch((error) => {
          this.setState({issaving:false})
          this.props.removeSaveProgress();
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
      })

      }
    }
  }

  render() {
    const language = this.props.Language.leaveplan;
    const { leaveTypes } = this.state;
    const { isDisabled } = this.state;
    const { selectedOptions } = this.state;
    const { issaveinprogress } = this.props.SaveInProgressReducer;

    let selectedOption;
    return (
      <IntlProvider locale="en" messages={language}>
        <main className="content-outer-wrapper">
          <div>
            <Helmet>
              <title>{headersList.Config.LeaveType.header}</title>
            </Helmet>
            <div>
              <p className="form-sub-header">
                {/* padding-left-30 */}
                <FormattedMessage
                  className="Select-the-Long-Leav margin-top-20"
                  id="LbSelectLeaveTypes"
                  defaultMessage="Select the leave types you would like to allow in your company"
                />{" "}
              </p>
              <Grid container>
                {/* className="padding-left-30" */}
                <Grid item xs={12} md={6} sm={12}>
                  {this.state.categorieTypes.length > 0
                    ? this.state.categorieTypes.map((item, i) => (
                        <div>
                          {/* <div className="requestCycleLabels margin-top-15">{item}</div> */}
                          <div className="form-input-label">
                            <FormattedMessage
                              className="margin-top-20 Select-the-Long-Leav"
                              id="LbSelectGeneralLeaveTypes"
                              defaultMessage="Select the"
                            />
                            &nbsp;{item}&nbsp;
                            <FormattedMessage
                              className="margin-top-20 Select-the-Long-Leav"
                              id="LbTypes"
                              defaultMessage="types"
                            />
                          </div>

                          <MenuList className="margintop-30 padding-top-0 ">
                            {Object.keys(leaveTypes).map((option) => (
                              <div>
                                {leaveTypes[option].map((item2) => {
                                  selectedOption = selectedOptions.filter(
                                    (x) => x.leavetypeid == item2.leavetypeid,
                                  );

                                  return (
                                    <div>
                                      {item2.categoryname == item ? (
                                        <MenuItem
                                          key={item2.leavetypeid}
                                          tabIndex="1"
                                          autofocus
                                          className={classNames(
                                            "bottom-border",
                                            selectedOption.length != 0
                                              ? "select-list-item"
                                              : "",
                                          )}
                                          onClick={this.HandleMultiSelect.bind(
                                            this,
                                            item2,
                                            true,
                                          )}
                                        >
                                          <ListItemText
                                            className="no-padding"
                                            inset
                                            primary={`${item2.leavetypename} ${
                                              item2.leavetypeid == 5 ||
                                              item2.leavetypeid == 4
                                                ? "*"
                                                : ""
                                            }`}
                                            // disableTypography={true}
                                          />
                                          {this.state.permissions.editable &&
                                          (item2.leavetypeid == 5 ||
                                            item2.leavetypeid == 4) ? (
                                            <img
                                              src={ActiveIcon}
                                              alt="icon"
                                              height="20"
                                            />
                                          ) : null}
                                          {this.state.permissions.editable &&
                                            selectedOptions.map((selectedId) =>
                                              selectedId.leavetypeid ==
                                                item2.leavetypeid &&
                                              selectedId.leavetypeid != 5 &&
                                              selectedId.leavetypeid != 4 ? (
                                                <div>
                                                  <img
                                                    src={ActiveIcon}
                                                    alt="icon"
                                                    height="20"
                                                  />
                                                </div>
                                              ) : null,
                                            )}
                                        </MenuItem>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  );
                                })}{" "}
                              </div>
                            ))}
                          </MenuList>

                          <div>
                            {this.state.errors.leaveTypes ? (
                              <span className="caption-error">
                                {" "}
                                <FormattedMessage
                                  id="ErServices"
                                  defaultMessage="select leave type"
                                />
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      ))
                    : ""}

                  {/* <div className="add-label-active requestCycleLabels margin-top-15"><FormattedMessage id="LbNotification" defaultMessage="Notifications" /></div>
                                    <div className="Select-the-Long-Leav" > <FormattedMessage className="margin-top-20 " id="LbNotification1" defaultMessage="Do you want to intimate employees when any leave type is made available to them?" /></div>
                                    <div tabIndex="2">
                                        <SelectList
                                            data={this.state.options}
                                            Selected={this.state.ismadeavailable}
                                            onSelected={this.UpdateLeavesAvailable.bind(this, 'ismadeavailable', true)}
                                        /></div> */}

                  {/*  <div className="Select-the-Long-Leav margin-top-40 margin-bottom-10" > <FormattedMessage className="add-label-active margin-top-20  " id="LbNotification2" defaultMessage="Do you want to intimate employees when any leave balance high?" /></div>

                                <div className="depedent-select-list" tabIndex="3"
                                    onClick={this.UpdatehighBalance.bind(this, 'isleavebalancehigh', true)}
                                    aria-expanded={this.state.isleavebalancehigh}>
                                    <span><FormattedMessage id="LbYes" defaultMessage="Yes" /></span>
                                    {this.state.isleavebalancehigh ? <span className="floatright"><img src={CheckImg} height="20" /></span> : <span className="not-selected"></span>}
                                </div>
                                <div className="et-level3" tabIndex="4">
                                    <Collapse in={this.state.isleavebalancehigh} timeout="auto" unmountOnExit className="padding30 overflow-initial">
                                        <FormattedMessage id="LbNotification3" defaultMessage="Mail should be triggered when leave balance is equal or greater than" />
                                        <span class="width200p">
                                        <span >
                                            <input className="seatlimit margin-left-10" tabIndex="5" min="1" type="number" id="noofemployee" placeholder="00"
                                                onChange={this.OnFieldChangeNumber.bind(this, true)} onClick={this.selHelperText.bind(this, true, "Helper text regarding getting high leave balance mail")}
                                                onKeyDown={this.HandleKeyDown.bind(this)} value={this.state.mailtriggereddays} maxLength="2"></input>
                                            <span className="inlindClass margin-left-10"><FormattedMessage id="LbNoOfDays" defaultMessage="Days" /></span>
                                        </span>
                                        </span>
                                        {this.state.TriggeredError == true ? <span className="caption-error"><FormattedMessage id="ErRoundOff" defaultMessage="Please add no. of days after which mail get triggered🙏" /></span> : ''}
                                    </Collapse>
                                </div>
                                <div className="depedent-select-list" tabIndex="6"
                                    onClick={this.UpdatehighBalance.bind(this, 'isleavebalancehigh', false)}
                                    aria-expanded={!this.state.isleavebalancehigh}>
                                    <span><FormattedMessage id="LbNo" defaultMessage="No" /></span>
                                    {!this.state.isleavebalancehigh ? <span className="floatright"><img src={CheckImg} height="20" /></span> : <span className="not-selected"></span>}
                                </div> */}
                </Grid>
              </Grid>
              <div className="draftbutton-wrapper">
                {this.state.permissions.editable ? (
                  <div
                    className="draftbutton-innerwrapper"
                   
                    onClick={this.onSaveClick.bind(this)}
                  >
                    <span className="draftbutton-save" tabIndex="7"  style={issaveinprogress ? { pointerEvents:"none", background:"rgba(1, 7, 9, 0.35)", cursor: "default"} : { cursor: "pointer" }}>
                      <DoneAllIcon />
                      <span className="draft-option1">Save </span>
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <Dialog
              fullWidth={true}
              maxWidth="sm"
              open={this.state.issaving}
              // onClose={() => this.setState({ openDialog: false, empform1: null })}
              aria-labelledby="max-width-dialog-title"
              classes={{
                scrollPaper: "no-shadow bg-transparent",
                paper: "no-shadow bg-transparent",
              }}
            >
              <DialogContent>
               <CustomLoader/>
              </DialogContent>
            </Dialog>
          </div>
        </main>
      </IntlProvider>
    );
  }
}

LeavePlanForm.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SaveInProgressReducer: state.SaveInProgressReducer,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      setHelperText: (data) => setHelperText(data),
      setSaveProgress,
      removeSaveProgress,
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(LeavePlanForm)));
